import {
  type ProgramId,
  type ProgramListInput,
  type ProgramStatsInput,
  type ProgramUserListInput,
  type UserId,
} from '@terros/common'
import { type QueryKey } from '@tanstack/react-query'

export const programKey = (programId: ProgramId): QueryKey => ['program', programId]
export const programListKey = (input?: ProgramListInput): QueryKey => {
  if (!input) return ['programs']
  return ['programs', input]
}
export const programUserKey = (programId: ProgramId, userId?: UserId): QueryKey => {
  if (!userId) return ['program-user', programId]
  return ['program-user', programId, userId]
}
export const programUsersKey = (programId?: ProgramId, props?: ProgramUserListInput): QueryKey => {
  if (!programId) return ['program-users']
  if (!props) return ['program-users', programId]
  return ['program-users', programId, props]
}
export const programUserInfiniteKey = (
  programId: ProgramId,
  props?: Omit<ProgramUserListInput, 'programId'>
): QueryKey => {
  if (!props) return ['program-user-infinite', programId]
  return ['program-user-infinite', programId, props]
}
export const programStatsKey = (input?: ProgramStatsInput): QueryKey => {
  if (!input) return ['program-stats']
  return ['program-stats', input]
}
